
import { ComparisonMap } from './comparison-map';

/**
 * 
 */
export class BasketsComparator {

  _comparisonMap;
  _basketWrapper
  isProcessingRetailerEvent;

  /**
   * 
   * @param {*} existingRetailerBasket 
   * @param {*} firstMiamBasket 
   * @param {*} comparisonMapClass 
   */
  constructor(basketWrapper, existingRetailerBasket, firstMiamBasket , comparisonMapClass = ComparisonMap) {
    this.isProcessingRetailerEvent = true;
    this._basketWrapper = basketWrapper
    this._comparisonMap = new comparisonMapClass(basketWrapper, existingRetailerBasket, firstMiamBasket);
    const toRemoveFromMiam = this._comparisonMap.resolveFromRetailer();
    this.sendUpdateToMiam(toRemoveFromMiam);
  }

  /**
   * 
   * @param {*} basket 
   */
  updateReceivedFromMiam(basket) {
    this._comparisonMap.setTargetFromMiam(basket);
    const toPushToRetailer = this._comparisonMap.resolveFromMiam(basket);
    this._comparisonMap.cleanNullProducts();
    this.sendUpdateToRetailer(toPushToRetailer);
  }

  /**
   * 
   * @param {*} retailerBasket 
   */
  updateReceivedFromRetailer(retailerBasket) {    
    this.isProcessingRetailerEvent = true;
    this._comparisonMap.updateMapFromRetailer(retailerBasket);
    const toRemoveFromMiam = this._comparisonMap.resolveFromRetailer();
    this._comparisonMap.cleanNullProducts();
    this.sendUpdateToMiam(toRemoveFromMiam);
  }

  /**
   * 
   * @param {*} entriesToRemove 
   * @returns 
   */
  sendUpdateToMiam(entriesToRemove) {
    // console.debug('will remove from miam', entriesToRemove);
    if (entriesToRemove.length === 0){
      // console.debug('stop processing retailer event');
      this.isProcessingRetailerEvent = false;
      return;
    }
    window.mealz.basket.removeEntries(entriesToRemove).subscribe(() => {
      // console.debug('stop processing retailer event');
      this.isProcessingRetailerEvent = false;
    });
  }

  /**
   * 
   * @param {*} itemsToAdd 
   * @returns 
   */
  sendUpdateToRetailer(itemsToAdd) {
    // console.debug('will update retailer', itemsToAdd);
    if (itemsToAdd.length === 0){
      return;
    }
    this._basketWrapper.pushProductsToBasket(itemsToAdd.map(item => { 
      return this._basketWrapper.mapEntryToProduct(item)
     }));
  }
  
}